import { Switch, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoonStars, IconSun } from '@tabler/icons-react';
import { use } from 'react';

import { ProjectContext } from '#core/contexts/ProjectContext.ts';

export function ColorSchemeToggleButton() {
  const { config } = use(ProjectContext);
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme(config?.defaultColorScheme);
  const toggleColorScheme = () => {
    setColorScheme(computedColorScheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <Switch
      checked={computedColorScheme === 'dark'}
      color="dark.8"
      label="Dark mode"
      offLabel={<IconSun color="var(--mantine-color-yellow-4)" size={16} stroke={2.5} />}
      onClick={toggleColorScheme}
      onLabel={<IconMoonStars color="var(--mantine-color-blue-6)" size={16} stroke={2.5} />}
    />
  );
}
